import Controller from '@ember/controller';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import AuthService from 'cio/services/auth';

export default class NoAccessibleWorkspacesController extends Controller {
  @service auth!: AuthService;

  astronautAmiFloatingImage = new URL('cio/assets/images/astronaut-ami-floating.gif', import.meta.url).toString();

  @action
  logout() {
    return this.auth.logout(true);
  }
}
